export default __webpack_public_path__ + "static/media/blac-chyna.5ef48c78.jpg";